<template>
  <v-overlay style="z-index: 10" :value="value">
    <v-card flat color="white" :width="$vuetify.breakpoint.smAndDown ? '80vw' : '640px'">
      <v-card-title class="default-color justify-space-between"
        >{{ title }} <v-icon size="24" color="#2b2b2b" @click="close">mdi-close</v-icon></v-card-title
      >
      <div class="px-4 w-100">
        <v-img :lazy-src="defaultImg" :src="imageUrl" contain aspect-ratio="1.7" class="rounded-lg">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
      <v-card-actions class="pb-4 pr-4">
        <v-spacer />
        <v-btn v-if="currentLevelIndex > 0" text color="primary" class="text-none" @click="previousImg">Anterior</v-btn>
        <v-btn v-if="currentLevelIndex < levelsToShow - 1" text color="primary" class="text-none" @click="nextImg"
          >Próxima</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>

<script>
import { PUBLIC_STORAGE_URL, PLACEHOLDER_AVATAR_PATH } from '@/constants/global'
export default {
  props: {
    value: {
      type: Boolean,
      required: false,
    },
    defaultImg: {
      type: String,
      default: PLACEHOLDER_AVATAR_PATH,
    },
    defaultPath: {
      type: String,
      default: PUBLIC_STORAGE_URL,
    },
    customTitle: {
      type: String,
      required: false,
    },
    useNormalSkin: {
      type: Boolean,
      default: true,
    },
    levelsToShow: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      levels: [
        { key: 'ausente', label: '0 - Ausente', imgName: 'normal-skin.png' },
        { key: 'leve', label: '1 - Leve', imgName: 'leve.jpg' },
        { key: 'moderado', label: '2 - Moderado', imgName: 'moderado.jpg' },
        { key: 'grave', label: '3 - Grave', imgName: 'grave.jpg' },
        { key: 'muito-grave', label: '4 - Muito grave', imgName: 'muito-grave.jpg' },
      ],
      currentLevelIndex: 0,
      skinProblem: '',
    }
  },
  computed: {
    // TODO: make this more flexible
    imageUrl() {
      if (this.currentLevelIndex === 0) {
        if (this.useNormalSkin) {
          return `${this.defaultPath}/${this.levels[this.currentLevelIndex].imgName}`
        }
        return `${this.defaultPath}/${this.skinProblem}-ausente.jpg`
      }

      return `${this.defaultPath}/${this.skinProblem}-${this.levels[this.currentLevelIndex].imgName}`
    },
    title() {
      if (this.customTitle) {
        return this.customTitle
      }
      return this.levels[this.currentLevelIndex].label
    },
  },
  methods: {
    setImgByLevel(level, skinProblem) {
      const levlIndex = this.levels.findIndex((item) => item.key === level)
      if (levlIndex !== -1) {
        this.currentLevelIndex = levlIndex
      }
      this.skinProblem = skinProblem
    },

    nextImg() {
      if (this.currentLevelIndex === this.levels.length - 1) {
        return
      }
      this.currentLevelIndex += 1
    },
    previousImg() {
      if (this.currentLevelIndex === 0) {
        return
      }
      this.currentLevelIndex -= 1
    },

    reset() {
      this.skinProblem = ''
      this.currentLevelIndex = 0
    },
    close() {
      this.$emit('input', false)
      this.reset()
    },
  },
}
</script>

<style scoped>
.default-color {
  color: #2b2b2b;
  font-size: 22px;
  font-weight: 400;
}
</style>
